import { TenderOffer } from 'types';

type UnitsByPlan = {
  total: number;
  phantoms: number;
  stocks: number;
  warrants: number;
};

type Eligible =
  | {
      type: 'PARTNER';
      units: number;
    }
  | {
      type: string;
      units: UnitsByPlan;
    };

type GetMaximumSaleUnitsProps = {
  eligible?: Eligible;
  tenderOffer: TenderOffer;
};

const min = (a?: number, b?: number) =>
  a != null && b != null ? Math.min(a, b) : undefined;

const percentOf = (value = 0, percent = 0) =>
  Math.floor((value * percent) / 100);

export const getMaximumSaleUnits = ({
  eligible,
  tenderOffer,
}: GetMaximumSaleUnitsProps): number => {
  if (!eligible) return 0;

  if (eligible.type === 'PARTNER') {
    return (eligible.units as number) ?? 0;
  }

  const units = eligible.units as UnitsByPlan;

  if (!units) return 0;

  if (tenderOffer?.sellAll) {
    return units.total;
  }

  if (tenderOffer?.maxUnits) {
    return min(units.total, tenderOffer.maxUnits) ?? 0;
  }

  if (tenderOffer?.maxPercentUnvested) {
    return percentOf(units.total, tenderOffer.maxPercentUnvested);
  }

  if (tenderOffer?.maxPhantoms) {
    return min(units.phantoms, tenderOffer.maxPhantoms) ?? 0;
  }

  if (tenderOffer?.maxPercentPhantoms) {
    return percentOf(units.phantoms, tenderOffer.maxPercentPhantoms);
  }

  if (tenderOffer?.maxStocks) {
    return min(units.stocks, tenderOffer.maxStocks) ?? 0;
  }

  if (tenderOffer?.maxPercentStocks) {
    return percentOf(units.stocks, tenderOffer.maxPercentStocks);
  }

  return 0;
};
